import './base-switch.scss';

import { useCallback, useEffect, useMemo, useState } from 'react';

import { makeKeyDownHandler } from '../../../data/utils/make-key-down-handler';

type BaseSwitchProps = {
  className?: string;
  testId?: string;
  value?: boolean;
  disabled?: boolean;
  title?: JSX.Element | string | number;
  onChange?: (value: boolean) => void;
};

export function BaseSwitch({
  testId,
  title,
  className,
  disabled = false,
  onChange,
  ...props
}: BaseSwitchProps) {
  const [selected, setSelected] = useState<boolean>(false);

  useEffect(() => {
    setSelected(props.value ?? false);
  }, [props.value]);

  const onHandleClick = useCallback(() => {
    setSelected(!selected);
    onChange?.(!selected);
  }, [selected, onChange]);

  const attributes = useMemo(() => {
    if (!disabled) {
      return {
        role: 'button',
        tabIndex: 0,
        onClick: onHandleClick,
        onKeyDown: makeKeyDownHandler(onHandleClick),
      };
    }

    return {};
  }, [disabled, onHandleClick]);

  return (
    <div
      {...attributes}
      data-test-id={testId}
      className={`form-switch${selected ? ' active' : ''}${
        disabled ? ' disabled' : ''
      }${className ? ` form-switch--${className}` : ''}`}
    >
      <i />
      {title && <span>{title}</span>}
    </div>
  );
}
